// extracted by mini-css-extract-plugin
export var actionText = "_kx-4";
export var container = "_kx-0";
export var leftSection = "_kx-1";
export var rightSection = "_kx-2";
export var settingsButton = "_kx-6";
export var settingsIcon = "_kx-7";
export var shortcut = "_kx-5";
export var shortcutGroup = "_kx-3";